/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemImpactEntrySchema } from './itemImpactEntrySchema';

export const itemChangeSubsetSchema = z.object({
  count: z.int(),
  get items() {
    return z.array(itemImpactEntrySchema);
  },
});
